import { Clock, UserPlus, Crown, Users, Star } from 'lucide-react'
import LoopPage from '../../components/LoopPage'

const stakeholders = [
  { icon: Clock, label: 'Long-tenured clients', description: 'Switching costs hide dissatisfaction. The novel perspective from a five-year client is harder to surface, and worth more.' },
  { icon: UserPlus, label: 'New clients', description: 'Where the relationship is forming. What is meeting the promise. Where it is not.' },
  { icon: Crown, label: 'Decision-makers', description: 'The person who renews the contract. What gets escalated to them, what does not, and how the gap got there.' },
  { icon: Users, label: 'End-users', description: 'The people who use what you deliver. Often invisible to the decision-maker. Often the source of the real feedback.' },
  { icon: Star, label: 'Champions', description: 'The internal advocates who renew, expand, and refer. Mine them for what would let them say more.' },
]

export default function ServiceLoop() {
  return (
    <LoopPage
      h1="Long relationships deserve real feedback."
      subhead="Account health checks, annual reviews, and renewal-window deep-dives that surface what QBRs are too polite to name."
      outerLoopSteps={['Deliver', 'Listen', 'Improve', 'Re-engage']}
      gapHeadline="'Everything's fine' until they leave"
      gapBody="Long-term clients say everything is fine — until they leave. Switching costs hide dissatisfaction. Quarterly business reviews are too polite to surface the truth. PrismScope runs conversations where clients can be honest, then synthesizes the patterns across your book of business."
      stakeholders={stakeholders}
      sampleRetro={{
        wentWell: 'Renewal-readiness up 22% in the top tier. Champion segment articulated value in shared language.',
        couldHaveBeenBetter: 'Two long-tenured accounts surfaced friction that never reached the CSM. Internal hand-offs missed end-user signal.',
        whatsNext: 'Add an annual end-user feedback loop, not just decision-maker. Adjust CSM cadence on tenure-5+ accounts.',
      }}
      audienceCallouts={[
        { title: 'For professional services and agencies', body: 'Run client feedback across decision-makers, end-users, and your own delivery team. Find the gap before the renewal conversation.' },
        { title: 'For B2B account managers', body: 'Stakeholder interviews across the buying committee. Capture the real renewal risk and expansion signal.' },
      ]}
      trackingPrefix="service-loop"
      seoTitle="Client & Account Feedback for Service Businesses"
      seoDescription="Account health checks, annual reviews, and renewal-window deep-dives that surface what quarterly business reviews are too polite to name."
      seoPath="/feedback-loops/service"
    />
  )
}
